import styled from "styled-components";

export const Container = styled.div`
  display: grid;
  gap: 12px;
  padding: 4px 0 8px;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  color: #212121;

  /* Itinerary: origin, destination and final location on a line, like the stops of a route */
  .itinerary {
    display: grid;
    margin: 0;
    padding: 0 0 10px;
    list-style: none;

    .stop {
      position: relative;
      display: grid;
      grid-template-columns: 32px minmax(0, 1fr);
      gap: 12px;
      padding-bottom: 14px;

      &::before {
        content: "";
        position: absolute;
        top: 34px;
        bottom: 2px;
        left: 15px;
        width: 2px;
        border-radius: 1px;
        background: #E0E0E0;
      }

      &.is-last {
        padding-bottom: 0;

        &::before {
          display: none;
        }
      }
    }

    .stop-icon {
      width: 32px;
      height: 32px;

      div, span {
        display: block;
        width: 32px;
        height: 32px;
      }

      svg {
        display: block;
        width: 32px;
        height: 32px;
      }
    }

    .stop-text {
      min-width: 0;
      padding-top: 1px;
    }

    .stop-label {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 6px;
      font-size: 11px;
      font-weight: 500;
      letter-spacing: 0.04em;
      text-transform: uppercase;
      color: #757575;
    }

    .stop-tag {
      padding: 1px 8px;
      border-radius: 999px;
      background: #F1F1F1;
      color: #424242;
      font-size: 11px;
      letter-spacing: 0;
      text-transform: none;
    }

    .stop-name {
      margin-top: 1px;
      font-size: 14.5px;
      font-weight: 500;
      line-height: 1.3;
    }

    .stop-address {
      margin-top: 2px;
      font-size: 12.5px;
      line-height: 1.4;
      color: #616161;
    }
  }

  /* Related data grouped in cards: the delivery note with its dates, the load with seal, volume and mix */
  .info-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
    gap: 10px;
  }

  .info-card {
    --tone: #1565C0;
    --tone-bg: #E3F2FD;

    display: grid;
    align-content: start;
    gap: 8px;
    min-width: 0;
    padding: 10px 12px;
    border: 1px solid #E6E8EB;
    border-radius: 10px;
    background: #FFFFFF;

    &.is-load {
      --tone: #E65100;
      --tone-bg: #FFF3E0;
    }

    &.is-travel {
      --tone: #455A64;
      --tone-bg: #ECEFF1;
    }
  }

  .info-card__header {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
  }

  .info-card__icon {
    display: grid;
    flex: none;
    place-items: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: var(--tone-bg);
    color: var(--tone);

    svg {
      width: 18px;
      height: 18px;
    }
  }

  .info-card__title {
    flex: 1;
    min-width: 0;
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #757575;
  }

  .info-card__headline {
    font-size: 18px;
    font-weight: 500;
    color: #212121;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
  }

  .info-card__rows {
    display: grid;
    margin: 0;
  }

  /* Label over its value, both aligned to the left under the card title */
  .info-card__row {
    display: grid;
    gap: 1px;
    padding: 6px 0;
    border-top: 1px solid #F1F2F4;

    dt {
      font-size: 12px;
      color: #757575;
    }

    dd {
      margin: 0;
      font-size: 13px;
      font-weight: 500;
      color: #212121;
      font-variant-numeric: tabular-nums;
      overflow-wrap: anywhere;
    }
  }

  .trace.MuiAccordion-root {
    margin: 0;
    border-top: 1px solid #F1F2F4;
    border-radius: 0;
    background: none;
    box-shadow: none;

    &::before {
      display: none;
    }

    .MuiAccordionSummary-root {
      min-height: 32px;
      padding: 0;

      .MuiAccordionSummary-content {
        margin: 0;
      }

      .MuiTypography-root {
        font-size: 12px;
        color: #757575;
      }
    }

    .MuiAccordionDetails-root {
      display: block;
      padding: 0 0 4px;

      .MuiTypography-root {

        .item {
          padding: 2px 0;
        }
      }
    }
  }
`;

export const ContainerTravelDataListItem = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 2.5px 0;
  font-size: 13px;

  .title {
    color: #757575;
    font-weight: 500;
    font-size: 12px;
  }
`;
